export function formatShortWalletAddress(address: string): string {
  return address.slice(0, 7) + "..." + address.slice(-5);
}
